export const START_30S_GAME_COMPLETED = "thirtySeconds/startCompleted";
export const SUBMIT_30S_GAME_COMPLETED = "thirtySeconds/submitCompleted";
export const GET_30S_SUGGESTIONS_COMPLETED = "thirtySeconds/suggestionsCompleted";
export const CLEAR_30S_SUGGESTIONS = "thirtySeconds/clearSuggestions";
